import { http } from "@/composable/httpService";
import { useHandleErrorStatus } from "@/composable/useHandleErrorStatus";
import { defineStore } from "pinia";
import { computed } from "vue";
import { ref } from "vue";

export const useUsersStore = defineStore("userStore", () => {
  const users = ref([]);
  const loadingUsers = ref(false);
  const selectedCompanyIds = ref([]);
  const selectedDealerIds = ref([]);

  const usersParams = computed(() => {
    return {
      dealer_ids: selectedCompanyIds.value,
      specific_dealer_ids: selectedDealerIds.value,
    };
  });

  const handleFetchUsers = async (params) => {
    try {
      loadingUsers.value = true;
      const { data } = await http().get("/client/lms/fetchUsersByDealer", {
        params: params ?? usersParams.value,
      });
      users.value = data;
    } catch (error) {
      useHandleErrorStatus(error);
    } finally {
      loadingUsers.value = false;
    }
  };

  return {
    handleFetchUsers,
    selectedCompanyIds,
    selectedDealerIds,
    users,
    loadingUsers,
  };
});
